import store from 'store';

const yandexMetric = (ymID) => {
  (function (m, e, t, r, i, k, a){
    m[i] = m[i] || function (){
      (m[i].a = m[i].a || []).push(arguments);
    };
    m[i].l = Number(new Date()); k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
  })
  (window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

  ym(ymID, 'init', {
    id: ymID,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true
  });

  window.ymw = ym.bind(null, ymID);

  window.ymReachGoal = (goalName) => {
    ym(ymID, 'reachGoal', goalName);
  };
};

const googleAnalytics = (gaId, fireInit, gaLocation) => {
  (function (i, s, o, g, r, a, m){
    i.GoogleAnalyticsObject = r; i[r] = i[r] || function (){
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = Number(new Date()); a = s.createElement(o),
    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m);
  })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

  ga('create', gaId, 'auto');

  if (fireInit) {
    ga('send', 'pageview', gaLocation ? {location: gaLocation} : '');
  }
};

const amplitudeMetric = (apiKey) => {
  (function (e, t){
    var n = e.amplitude || {_q: [], _iq: {}}; var r = t.createElement('script');
    r.type = 'text/javascript';
    r.integrity = 'sha384-RsEu4WZflrqYcEacpfoGSib3qaSvdYwT4D+DrWqeBuDarSzjwUQR1jO8gDiXZd0E';
    r.crossOrigin = 'anonymous'; r.async = true;
    r.src = 'https://cdn.amplitude.com/libs/amplitude-6.2.0-min.gz.js';
    r.onload = function (){
      if (!e.amplitude.runQueuedFunctions){
        console.log('[Amplitude] Error: could not load SDK');
      }
    };
    var i = t.getElementsByTagName('script')[0]; i.parentNode.insertBefore(r, i);
    function s (e, t){
      e.prototype[t] = function (){
        this._q.push([t].concat(Array.prototype.slice.call(arguments, 0))); return this;
      };
    }
    var o = function (){
      this._q = []; return this;
    };
    var a = ['add', 'append', 'clearAll', 'prepend', 'set', 'setOnce', 'unset'];
    for (var u = 0; u < a.length; u++){
      s(o, a[u]);
    }n.Identify = o; var c = function (){
      this._q = [];
      return this;
    };
    var l = ['setProductId', 'setQuantity', 'setPrice', 'setRevenueType', 'setEventProperties'];
    for (var p = 0; p < l.length; p++){
      s(c, l[p]);
    }n.Revenue = c;
    var d = ['init', 'logEvent', 'logRevenue', 'setUserId', 'setUserProperties', 'setOptOut', 'setVersionName', 'setDomain', 'setDeviceId', 'enableTracking', 'setGlobalUserProperties', 'identify', 'clearUserProperties', 'setGroup', 'logRevenueV2', 'regenerateDeviceId', 'groupIdentify', 'onInit', 'logEventWithTimestamp', 'logEventWithGroups', 'setSessionId', 'resetSessionId'];
    function v (e){
      function t (t){
        e[t] = function (){
          e._q.push([t].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      for (var n = 0; n < d.length; n++){
        t(d[n]);
      }
    }v(n); n.getInstance = function (e){
      e = (!e || e.length === 0 ? '$default_instance' : e).toLowerCase();
      if (!n._iq.hasOwnProperty(e)){
        n._iq[e] = {_q: []}; v(n._iq[e]);
      } return n._iq[e];
    };
    e.amplitude = n;
  })(window, document);

  amplitude.getInstance().init(apiKey);
};

function setupYmReachGaol() {
  if (!window.ymReachGoal) {
    window.ymReachGoal = () => {};
  }

  window.ymTabActivate = (tabName) => {
    const account = store.getters['accounts/currentAccount'];
    const projectId = store.getters['projects/currentProjectId'];
    const goalNamePattern = 'TABS_GOTO_{0}_{1}';
    const tab = tabName ? tabName.toUpperCase() : tabName;

    // track goal if tab has project or account
    if (projectId) {
      return window.ymReachGoal(goalNamePattern.format('PROJECT', tab));
    }
    if (account) {
      return window.ymReachGoal(goalNamePattern.format(account.type, tab));
    }
  };
}

export default function setupMetrics (config) {
  if (config.LAYOUT_YANDEX_METRIKA_ID) {
    yandexMetric(config.LAYOUT_YANDEX_METRIKA_ID);
  }
  setupYmReachGaol();

  if (config.LAYOUT_GOOGLE_ANALYTICS_ID) {
    googleAnalytics(config.LAYOUT_GOOGLE_ANALYTICS_ID);
  }

  if (config.LAYOUT_AMPLITUDE_API_KEY) {
    amplitudeMetric(config.LAYOUT_AMPLITUDE_API_KEY);
  }

}
